import React from 'react';
import moment from 'moment';
import { FaBoxOpen, FaArrowDown } from 'react-icons/fa';
import { useTranslation } from '../../Context/LanguageContext';

const LatestOrderList = (props) => {
  const { escrows } = props;
  const { t } = useTranslation();

  if (!escrows || escrows.length === 0) {
    return (
      <div className='d-flex flex-column align-items-center justify-content-center py-5'>
        <FaBoxOpen size={40} className='text-muted mb-3 opacity-5' />
        <h6 className='text-muted font-weight-normal'>
          {t('noRecentOrders')}
        </h6>
      </div>
    );
  }

  return (
    <>
      {escrows.map((escrow, index) => (
        <li
          key={index}
          className='list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg bg-transparent'
        >
          <div className='d-flex align-items-center'>
            <button className='btn btn-icon-only btn-rounded btn-outline-success mb-0 me-3 btn-sm d-flex align-items-center justify-content-center'>
              <FaArrowDown />
            </button>
            <div className='d-flex flex-column'>
              <h6 className='mb-1 text-sm' style={{ color: 'var(--text-primary)' }}>{escrow.myName}</h6>
              <span className='text-xs text-muted'>
                {' '}
                {moment(escrow?.createdAt).format('DD MMM YYYY, hh:mm A')}
              </span>
            </div>
          </div>
          <div className='d-flex align-items-center text-success text-gradient text-sm font-weight-bold'>
            {escrow?.invoiceAmt
              ? parseFloat(escrow?.invoiceAmt) +
                parseFloat(escrow?.additionalAmt)
              : 0}
          </div>
        </li>
      ))}
    </>
  );
};

export default LatestOrderList;
